export default "__VITE_ASSET__C3Uu0jkC__"